import { Analytics } from '@/types'

function track<N extends Analytics.EventTypes> (
  event: N,
  properties: Analytics.EventParams<N>
): void {
  window.analytics.track(event, properties as object)
}

const page = window.analytics.page

const identify = window.analytics.identify

export default {
  track,
  identify,
  page
}
